export default "__VITE_ASSET__VOsYTDT7__"